import { render, staticRenderFns } from "./QuizSimple.vue?vue&type=template&id=1492e391&scoped=true&"
import script from "./QuizSimple.vue?vue&type=script&lang=js&"
export * from "./QuizSimple.vue?vue&type=script&lang=js&"
import style0 from "./QuizSimple.vue?vue&type=style&index=0&id=1492e391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492e391",
  null
  
)

export default component.exports